export default __webpack_public_path__ + "b2abdb73af73dde3975f13ede26ed9c5.jpg";